import { confirm } from "@bps/fluent-ui";
import { useStores } from "@stores/hooks/useStores.ts";
import { Contact } from "@stores/practice/models/Contact.ts";
import { usePatientLabel } from "@ui-components/hooks/usePatientLabel.ts";

export const usePatientMergeHandling = (contact: Contact) => {
  const { practice, core } = useStores();
  const patientLabel = usePatientLabel();

  const handleMergePatient = async () => {
    const orgUnit = await practice.getOrgUnit(core.location?.id);
    const isPhysitrackEnabled = orgUnit?.orgUnitEnabledPhysitrack?.enabled;

    if (isPhysitrackEnabled) {
      const subText = `Your practice has a Physitrack integration. Ensure you merge your master and duplicate ${patientLabel} in Physitrack (if they both exist) before proceeding with your Omni merge`;

      const continueMergePatient = await confirm({
        confirmButtonProps: { text: "Continue to merge" },
        dialogContentProps: {
          title: "Physitrack integration reminder",
          subText
        }
      });

      if (!continueMergePatient) return;
    }

    practice.ui.setShowPatientMergeModal(true);
    practice.ui.setMasterPatient(contact);
  };

  return { handleMergePatient };
};
